import Axios from "axios";

import { 
  SET_BONUS_TYPE_LIST, 
  UNSET_BONUS_TYPE_LIST,
  SET_BONUS_TYPE_DETAILS,
  UNSET_BONUS_TYPE_DETAILS,
  SET_BONUS_PROCESS_LIST,
  UNSET_BONUS_PROCESS_LIST,
  SET_EMPLOYEE_BONUS_LIST,
  UNSET_EMPLOYEE_BONUS_LIST,
  SET_EMPLOYEE_BONUS_DETAILS,
  UNSET_EMPLOYEE_BONUS_DETAILS,
  SET_BONUS_PROCESS_DETAILS_LIST,
  UNSET_BONUS_PROCESS_DETAILS_LIST,
  SET_BONUS_PAYMENT_LIST,
  UNSET_BONUS_PAYMENT_LIST,
  SET_BONUS_PAYMENT_INVOICE_DETAILS,
  UNSET_BONUS_PAYMENT_INVOICE_DETAILS,
  } from "@/store/mutation-types";


import {
  getBonusTypeList as getBonusTypeListApi,
  getBonusTypeById as getBonusTypeByIdApi,
  saveUpdateBonusType as saveUpdateBonusTypeApi,
  saveUpdateBonusProcess as saveUpdateBonusProcessApi,
  bonusProcessList as bonusProcessListApi,
  employeeBonusList as employeeBonusListApi,
  employeeBonusDetails as employeeBonusDetailsApi,
  bonusPayment as bonusPaymentApi,
  bonusPaymentList as bonusPaymentListApi,
} from "@/store/api";

const state = {
  getBonusTypeList: [],
  getBonusProcessList: [],
  getBonusProcessDetailsList: [],
  getEmployeeBonusList : [],
  getEmployeeBonusDetails : [],
  editingBonusType: null,
  getBonusTypeDetails: null,
  getBonusPaymentList: [],
  getBonusPaymentInvoice: [],
};


const getters = {
  getBonusTypeList(state) {
    return state.getBonusTypeList;
  },
  getBonusProcessList(state) {
    return state.getBonusProcessList;
  },
  getBonusProcessDetailsList(state) {
    return state.getBonusProcessDetailsList;
  },
  getEmployeeBonusDetails(state){
    return state.getEmployeeBonusDetails;
  },
  editingBonusType: (state) => state.editingBonusType,
  getBonusTypeDetails(state) {
    return state.getBonusTypeDetails;
  },
  getEmployeeBonusList(state){
    return state.getEmployeeBonusList;
  },
  getBonusPaymentList(state){
    return state.getBonusPaymentList;
  },
  getBonusPaymentInvoice(state){
    return state.getBonusPaymentInvoice;
  }
  
};


// Mutations
const mutations = {
  [SET_BONUS_TYPE_LIST](state, data) {
    state.getBonusTypeList = data;
  },
  [UNSET_BONUS_TYPE_LIST](state) {
    state.getBonusTypeList = [];
  },
  [SET_BONUS_TYPE_DETAILS](state, data) {
    state.getBonusTypeDetails = data;
  },
  [UNSET_BONUS_TYPE_DETAILS](state) {
    state.getBonusTypeDetails = null;
  },
  [SET_BONUS_PROCESS_LIST](state, data) {
    state.getBonusProcessList = data;
  },
  [UNSET_BONUS_PROCESS_LIST](state) {
    state.getBonusProcessList = [];
  },
  [SET_BONUS_PROCESS_DETAILS_LIST](state, data) {
    state.getBonusProcessDetailsList = data;
  },
  [UNSET_BONUS_PROCESS_DETAILS_LIST](state) {
    state.getBonusProcessDetailsList = [];
  },
  [SET_EMPLOYEE_BONUS_LIST](state, data) {
    state.getEmployeeBonusList = data;
  },
  [UNSET_EMPLOYEE_BONUS_LIST](state) {
    state.getEmployeeBonusList = [];
  },
  [SET_EMPLOYEE_BONUS_DETAILS](state, data) {
    state.getEmployeeBonusDetails = data;
  },
  [UNSET_EMPLOYEE_BONUS_DETAILS](state) {
    state.getEmployeeBonusDetails = [];
  },
  editingBonusType(state, bonusType) {
    state.getBonusTypeDetails = bonusType;
  },
  [SET_BONUS_PAYMENT_LIST](state, data) {
    state.getBonusPaymentList = data;
  },
  [UNSET_BONUS_PAYMENT_LIST](state) {
    state.getBonusPaymentList = [];
  },

  [SET_BONUS_PAYMENT_INVOICE_DETAILS](state, data) {
    state.getBonusPaymentInvoice = data;
  },
  [UNSET_BONUS_PAYMENT_INVOICE_DETAILS](state) {
    state.getBonusPaymentInvoice = [];
  },

  
};

// Actions
const actions = {

    saveUpdateBonusPayment({ commit }, data) {
      commit("SET_LOADING", {color: "primary"});
      return new Promise((resolve, reject) => {
      Axios.post(bonusPaymentApi, data)
          .then(function (response) {
          resolve(response);
          })
          .catch(function (error) {

          reject(error);
          })
          .then((always) => {
              commit("UNSET_LOADING");
          });
      });
    },

    saveUpdateBonusProcess({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateBonusProcessApi, data)
            .then(function (response) {
            resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    saveUpdateBonusType({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateBonusTypeApi, data)
            .then(function (response) {
            resolve(response);
            })
            .catch(function (error) {

            reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getBonusTypeList({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.get(`${getBonusTypeListApi}`, { params: data })
            .then((response) => {
            commit(SET_BONUS_TYPE_LIST, response.data.data || []);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_BONUS_TYPE_LIST);
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getBonusProcessList({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.get(`${bonusProcessListApi}`, { params: data })
            .then((response) => {
            commit(SET_BONUS_PROCESS_LIST, response.data.data || []);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_BONUS_PROCESS_LIST);
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getBonusProcessDetailsList({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.get(`${bonusProcessListApi}/${data}`)
            .then((response) => {
            commit(SET_BONUS_PROCESS_DETAILS_LIST, response.data.data.details || []);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_BONUS_PROCESS_DETAILS_LIST);
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getEmployeeBonusList({commit}, data){
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.get(`${employeeBonusListApi}`, { params: data })
            .then((response) => {
            commit(SET_EMPLOYEE_BONUS_LIST, response.data.data || []);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_EMPLOYEE_BONUS_LIST);
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },
    getEmployeeBonusDetails({ commit }, id) {

      commit("SET_LOADING", { color: "primary" });

      return new Promise((resolve, reject) => {
        Axios.get(`${employeeBonusDetailsApi}/${id}`)
          .then((response) => {
            commit(SET_EMPLOYEE_BONUS_DETAILS, response.data.data || []);
            resolve(response);
          })
          .catch((error) => {
            commit(UNSET_EMPLOYEE_BONUS_DETAILS);
            reject(error);
          })
          .finally(() => {
            commit("UNSET_LOADING");
          });
      });
    },
    getBonusTypeDetails({ commit }, bonus_type_id) {
      commit("SET_LOADING", { color: "primary" });

      return new Promise((resolve, reject) => {
          Axios.get(`${getBonusTypeByIdApi}/${bonus_type_id}`)
          .then((response) => {
              commit("SET_BONUS_TYPE_DETAILS", response.data.data || []);
              resolve(response);
          })
          .catch((error) => {
              commit("UNSET_BONUS_TYPE_DETAILS");
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING");
          });
      });
    },
    getBonusPaymentList({ commit }, data) {
      commit("SET_LOADING", { color: "primary" });

      return new Promise((resolve, reject) => {
          Axios.get(`${bonusPaymentListApi}`, {params:data})
          .then((response) => {
              commit("SET_BONUS_PAYMENT_LIST", response.data.data || []);
              resolve(response);
          })
          .catch((error) => {
              commit("UNSET_BONUS_PAYMENT_LIST");
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING");
          });
      });
    },
    getBonusPaymentInvoice({ commit }, data) {
      commit("SET_LOADING", { color: "primary" });

      return new Promise((resolve, reject) => {
          Axios.get(`${bonusPaymentListApi}/${data}`)
          .then((response) => {
              commit("SET_BONUS_PAYMENT_INVOICE_DETAILS", response.data.data || []);
              resolve(response);
          })
          .catch((error) => {
              commit("UNSET_BONUS_PAYMENT_INVOICE_DETAILS");
              reject(error);
          })
          .finally(() => {
              commit("UNSET_LOADING");
          });
      });
    },

  
};


export default {
  state,
  getters,
  actions,
  mutations,
};